import React, { useEffect } from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { connect } from "react-redux";

const styles = StyleSheet.create({
  Header: { margin: 4, fontSize: "12", fontWeight: "bold" },
  header2: { margin: 4, fontSize: "17", fontWeight: "bold" },
  splitRow1: {
    width: "55%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
  },
  splitRow2: {
    width: "45%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  singleRow: {
    width: "100%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0,
  },
  tableCellSplitStyle: {
    margin: 5,
    fontSize: 11,
    paddingBottom: 15,
  },
  tableCellLabel: {
    margin: 5,
    fontSize: 11,
  },
  tableCellText: {
    fontSize: 8,
    marginLeft: 5,
    marginBottom: 5,
  },
});

const SoaDocument1 = (props) => {
  //console.log("clspdf",props.pdfData)

  // const fetchedData = JSON.parse(localStorage.getItem("data"));
  // const { pcpName, email, gender } = fetchedData;
  // const pcpName1 = () => {
  //   return (
  //   `${pcpName}`
  // )};
  // const email1 = () => {return(`${email}`)};
  // const gender1 = () => {return(`${gender}`)};
  const createTableHeader = () => {
    return (
      <View style={tableRowStyle} fixed>
        <View style={firstTableColHeaderStyle}>
          <Text style={styles.Header}>To be completed by agent:</Text>
        </View>
      </View>
    );
  };

  return (
    <Document>
      <Page style={pageStyle} size="A4" orientation="portrait">
        <View>
          <Text style={{ textAlign: "center" }}>Align Senior Care</Text>
        </View>
        <View>
          <Text style={{ textAlign: "center" }}>
            Scope of Sales Appointment Confirmation Form
          </Text>
        </View>
        <View>
          <Text style={{ fontSize: "11", marginTop: "5" }}>
            The Centers for Medicare & Medicaid Services requires agents to
            document the scope of a marketing appointment prior to any
            face-to-face sales meeting to ensure understanding of what will be
            discussedbetween the agent and the Medicare beneficiary (or their
            authorized representative). All information provided on this form is
            confidential and should be completed by each person with Medicare or
            his/her authorized representative.
          </Text>
        </View>
        <View style={box}>
          <Text style={{ fontSize: "11", fontWeight: "bold" }}>
            Please check (X) below the types of product(s) you would like the
            agent to discuss
          </Text>
          <Text style={{ fontSize: "11", marginTop: 10 }}>
            (Refer to page 2 for product type descriptions.)
          </Text>
          <Text style={{ fontSize: "13", marginTop: 10 }}>
            ______Align Premier (HMO I-SNP)
          </Text>
          <Text style={{ fontSize: "13", marginTop: 10, marginLeft: -10 }}>
            ______Align Thrive (HMO I-SNP)
          </Text>
          <Text style={{ fontSize: "13", marginTop: 10 }}>
            ______Align Connect (HMO C-SNP)
          </Text>
          <Text style={{ fontSize: "13", marginTop: 10, marginLeft: 15 }}>
            ______Align Kidney Care (HMO C-SNP)
          </Text>
        </View>
        <View style={{ fontSize: "11", marginTop: "15", marginBottom: "7" }}>
          <Text style={{ fontWeight: "bold" }}>
            By signing this form, you agree to meeting with a sales agent to
            discuss the types of products you checked (X) above. Please note,
            the person who will discuss the products is either employed or
            contracted by a Medicare plan. They do not work directly for the
            Federal government. This individual may also be paid based on your
            enrollment in a plan. Signing this form does NOT obligate you to
            enroll in a plan, affect your current enrollment, or enroll you in a
            Medicare plan.
          </Text>
        </View>
        <View style={tableStyle}>
          {createTableHeader()}
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>Agent Name :</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData.agentName}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>Agent Phone :</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData?.agentPh
                  ? props.pdfData.agentPh?.length <= 10
                    ? "(" +
                      props.pdfData.agentPh.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData.agentPh.slice(3, 6) +
                      "-" +
                      props.pdfData.agentPh.slice(6, 11)
                    : props.pdfData.agentPh
                  : props.pdfData?.agentPhone?.length <= 10
                  ? "(" +
                    props.pdfData.agentPhone.slice(0, 3) +
                    ")" +
                    " " +
                    props.pdfData.agentPhone.slice(3, 6) +
                    "-" +
                    props.pdfData.agentPhone.slice(6, 11)
                  : props.pdfData?.agentPhone}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>Beneficiary Name :</Text>
              <Text style={styles.tableCellText}>
                {props.dashboard === "prospect"
                  ? props.pdfData?.beneName
                  : props.pdfData.benName
                  ? props.pdfData.benName
                  : props.pdfData.beneficiaryName}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>
                Beneficiary Phone (Optional) :
              </Text>
              <Text style={styles.tableCellText}>
                {props.pdfData?.benePhone
                  ? props.pdfData?.benePhone?.length <= 10
                    ? "(" +
                      props.pdfData?.benePhone.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData?.benePhone.slice(3, 6) +
                      "-" +
                      props.pdfData?.benePhone.slice(6, 11)
                    : props.pdfData?.benePhone
                  : props.pdfData.benPh
                  ? props.pdfData.benPh.length <= 10
                    ? "(" +
                      props.pdfData.benPh.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData?.benPh.slice(3, 6) +
                      "-" +
                      props.pdfData?.benPh.slice(6, 11)
                    : props.pdfData?.benPh
                  : props.pdfData?.beneficiaryPhone
                  ? props.pdfData?.beneficiaryPhone?.length <= 10
                    ? "(" +
                      props.pdfData?.beneficiaryPhone.slice(0, 3) +
                      ")" +
                      " " +
                      props.pdfData?.beneficiaryPhone.slice(3, 6) +
                      "-" +
                      props.pdfData?.beneficiaryPhone.slice(6, 11)
                    : props.pdfData?.beneficiaryPhone
                  : ""}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellLabel}>
                Beneficiary Address (Optional):
              </Text>
              <Text style={styles.tableCellText}>
                {props.dashboard === "prospect"
                  ? props.pdfData.beneAddress
                  : props.pdfData.benAdd
                  ? props.pdfData.benAdd
                  : props.pdfData.beneficiaryAddress}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellLabel}>
                Initial Method of Contact: (Indicate here if beneficiary was a
                walk-in)
              </Text>
              <Text style={styles.tableCellText}>
                {props.pdfData?.contact?.toUpperCase()?.includes("SALE") ||
                props.pdfData.initialMethodOfContact
                  ?.toUpperCase()
                  ?.includes("SALE")
                  ? "Sales event"
                  : props.pdfData?.contact?.toUpperCase()?.includes("PERMI") ||
                    props.pdfData.initialMethodOfContact
                      ?.toUpperCase()
                      ?.includes("PERMI")
                  ? "Permission to call card"
                  : props.pdfData?.contact?.toUpperCase()?.includes("WALK") ||
                    props.pdfData.initialMethodOfContact
                      ?.toUpperCase()
                      ?.includes("WALK")
                  ? "Walk-in"
                  : props.pdfData?.contact?.toUpperCase()?.includes("INBOU") ||
                    props.pdfData.initialMethodOfContact
                      ?.toUpperCase()
                      ?.includes("INBOU")
                  ? "Inbound Call"
                  : props.pdfData?.contact?.toUpperCase()?.includes("OUTBO") ||
                    props.pdfData.initialMethodOfContact
                      ?.toUpperCase()
                      ?.includes("OUTBO")
                  ? "OUTBOUND CALL"
                  : props.pdfData?.contact?.toUpperCase()?.includes("OTH") ||
                    props.pdfData.initialMethodOfContact
                      ?.toUpperCase()
                      ?.includes("OTH")
                  ? "Other"
                  : ""}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellLabel}>Agent’s Signature:</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData.agentSign
                  ? props.pdfData.agentSign
                  : props.pdfData.agentSignutre}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>
                Plan(s) the agent represented during this meeting:
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>
                Date Appointment Completed:
              </Text>
              <Text style={styles.tableCellText}>
                {props.dashboard == "prospect"
                  ? props.pdfData?.appointmentDateComp
                  : props.pdfData.dac
                  ? props.pdfData.dac
                  : props.pdfData.dateApntmntCmpltd}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle} fixed>
            <View style={firstTableColHeaderStyle}>
              <Text style={styles.Header}>
                Beneficiary or Authorized Representative Signature and Signature
                Date:
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>Signature: </Text>
              <Text style={styles.tableCellText}>
                {props.dashboard === "prospect"
                  ? props.pdfData?.beneRepSignature
                  : props.pdfData.signature
                  ? props.pdfData.signature
                  : props.pdfData.repSignature}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>Signature Date: </Text>
              <Text style={styles.tableCellText}>
                {props.dashboard === "prospect"
                  ? props.pdfData?.beneRepSignDate
                  : props.pdfData.date
                  ? props.pdfData.date
                  : props.pdfData.repDate}
              </Text>
            </View>
          </View>
          <View style={tableRowStyle} fixed>
            <View style={firstTableColHeaderStyle}>
              <Text style={styles.Header}>
                If you are the authorized representative, please sign above and
                print below:
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.splitRow1}>
              <Text style={styles.tableCellLabel}>Representative’s Name:</Text>
              <Text style={styles.tableCellText}>
                {props.pdfData.name
                  ? props.pdfData.name
                  : props.pdfData.repName}
              </Text>
            </View>

            <View style={styles.splitRow2}>
              <Text style={styles.tableCellLabel}>
                Relationship to the Beneficiary:{" "}
              </Text>
              <Text style={styles.tableCellText}>
                {props.pdfData?.relationship === "SELF" ||
                props.pdfData?.repRelationShip === "SELF" ||
                props.pdfData?.relationshipToBene === "SELF"
                  ? props.pdfData?.repRelationShip
                  : props.component === "fullrelation"
                  ? props.authorizedrelations.filter(
                      (data) =>
                        data.value ==
                        (props.pdfData.repRelationShip
                          ? props.pdfData.repRelationShip
                          : props.pdfData.relationship)
                    )[0]?.label
                  : props.dashboard === "prospect"
                  ? props.authorizedrelations.filter(
                      (data) =>
                        data.value ==
                        (props.pdfData?.relationshipToBene
                          ? props.pdfData?.relationshipToBene
                          : "")
                    )[0]?.label
                  : ""}
              </Text>
            </View>
          </View>
          {/* {createTableRow()}
          {createTableRow()}
          {createTableRow()}
          {createTableRow()} */}
        </View>
        <View style={{ fontSize: "11", marginTop: "12", textAlign: "center" }}>
          <Text>
            *Scope of Appointment documentation is subject to CMS record
            retention requirements*
          </Text>
        </View>
        <View style={{ fontSize: 13, textAlign: "left", marginTop: 5 }}>
          <Text>H3274_2023SOA_C </Text>
        </View>
        <View style={{ fontSize: 13, textAlign: "right", marginTop: -13 }}>
          <Text>© Align Senior Care 2022</Text>
        </View>
      </Page>
      <Page style={pageStyle} size="A4" orientation="portrait">
        <View style={tableStyle}>
          <View style={tableRowStyle} fixed>
            <View style={firstTableColHeaderStyle}>
              <Text style={styles.header2}>Align Senior Care</Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellSplitStyle}>
                Medicare Health Maintenance Organization (HMO) is a Medicare
                Advantage plan that provides all Original Medicare Part A and
                Part B health coverage and sometimes covers Part D prescription
                drug coverage. In most HMOs you can only get your care from
                doctors or hospitals in the plan’s network (except in
                emergencies).
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellSplitStyle}>
                Institutional Special Needs Plans (I-SNP) are Medicare Advantage
                plans with benefit packages for people with special health care
                needs. The I-SNP is designed for people who, for 90 days or
                longer, have had or are expected to need the level of services
                provided in an institutional level of care.
              </Text>
            </View>
          </View>
          <View style={tableRowStyle}>
            <View style={styles.singleRow}>
              <Text style={styles.tableCellSplitStyle}>
                Chronic Condition Special Needs Plans(C-SNP) are Medicare
                Advantage plans that provide a benefit package for people with
                special health care needs.This C-SNP is designed for people who
                qualify for a specific severe or disabling chronic condition.
              </Text>
            </View>
          </View>
        </View>
        <View style={{ fontSize: 12, marginTop: 450 }}>
          <Text>
            Align Senior Care is an HMO I-SNP and HMO C-SNP with a Medicare
            contract. Enrollment in Align Senior Care plans depend on contract
            renewal. Align Senior Care complies with applicable Federal civil
            rights laws and does not discriminate on the basis of race, color,
            national origin, age, disability, or sex. ATENCIÓN: si habla
            español, tiene a su disposición servicios gratuitos de asisten-cia
            lingüística. Llame al 1-844-305-3879 (TTY 711)
          </Text>
        </View>

        <View style={{ fontSize: 13, textAlign: "left", marginTop: 10 }}>
          <Text>H3274_2023SOA_C</Text>
        </View>
        <View style={{ fontSize: 13, textAlign: "right", marginTop: -13 }}>
          <Text>© Align Senior Care 2022</Text>
        </View>
      </Page>
    </Document>
  );
};

const box = {
  marginLeft: 18,
  width: "90%",
  display: "table",
  backgroundColor: "#bdbdbd",
  top: "10",
  paddingTop: "15",
  paddingBottom: "15",
  textAlign: "center",
};
const pageStyle = {
  paddingTop: 16,
  paddingHorizontal: 40,
  paddingBottom: 56,
};

const tableStyle = {
  display: "table",
  width: "auto",
};

const tableRowStyle = {
  flexDirection: "row",
};

const firstTableColHeaderStyle = {
  width: "100%",
  borderStyle: "solid",
  borderColor: "#000",
  borderBottomColor: "#000",
  borderWidth: 1,
  backgroundColor: "#bdbdbd",
};

const tableColHeaderStyle = {
  width: "20%",
  borderStyle: "solid",
  borderColor: "#000",
  borderBottomColor: "#000",
  borderWidth: 1,
  borderLeftWidth: 0,
  backgroundColor: "#bdbdbd",
};

const firstTableColStyle = {
  width: "20%",
  borderStyle: "solid",
  borderColor: "#000",
  borderWidth: 1,
  borderTopWidth: 0,
};

const tableColStyle = {
  width: "20%",
  borderStyle: "solid",
  borderColor: "#000",
  borderWidth: 1,
  borderLeftWidth: 0,
  borderTopWidth: 0,
};

const tableCellHeaderStyle = {
  textAlign: "center",
  margin: 4,
  fontSize: "12",
  fontWeight: "bold",
};

const tableCellStyle = {
  textAlign: "center",
  margin: 5,
  fontSize: 10,
};
const mapStateToProps = (state) => {
  return {
    pdfData: state.webApp.pdfData,
  };
};

const mapDispatchToProps = {};

//export default connect(mapStateToProps, mapDispatchToProps)(TableDocument);
export default SoaDocument1;
